import api from './api';
import { Vertrag, CreateVertragRequest, UpdateVertragRequest, BeendeVertragRequest } from '../types';

export const vertragService = {
  getAll: async (): Promise<Vertrag[]> => {
    const response = await api.get('/vertraege');
    return response.data;
  },
  getByKunde: async (kundeId: number): Promise<Vertrag[]> => {
    const response = await api.get(`/vertraege?kundeId=${kundeId}`);
    return response.data;
  },
  getByGrab: async (grabId: number): Promise<Vertrag[]> => {
    const response = await api.get(`/vertraege?grabId=${grabId}`);
    return response.data;
  },
  getByTier: async (tierId: number): Promise<Vertrag[]> => {
    const response = await api.get(`/vertraege?tierId=${tierId}`);
    return response.data;
  },
  getById: async (id: number): Promise<Vertrag> => {
    const response = await api.get(`/vertraege/${id}`);
    return response.data;
  },
  create: async (data: CreateVertragRequest): Promise<Vertrag> => {
    const response = await api.post('/vertraege', data);
    return response.data;
  },
  update: async (id: number, data: UpdateVertragRequest): Promise<Vertrag> => {
    const response = await api.put(`/vertraege/${id}`, data);
    return response.data;
  },
  beenden: async (id: number, data: BeendeVertragRequest): Promise<Vertrag> => {
    const response = await api.post(`/vertraege/${id}/beenden`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/vertraege/${id}`);
  }
};

export default vertragService;
